export const MuiDialog = () => ({
  styleOverrides: {
    root: {
      '& .MuiPaper-root': {
        margin: 0,
        textAlign: 'center',
      },
      '& .MuiBackdrop-root': {
        backgroundColor: 'rgba(52, 64, 84, 0.6)',
        backdropFilter: 'blur(2.5px)',
      },
    },
  },
});
